import React from "react";
type SectionTitleProps = {
  id: string;
  title: string;
  highlight?: string;
  after?: string;
  tone?: "light" | "dark";
  as?: "h1" | "h2";
  className?: string;
};
export function SectionTitle({
  id,
  title,
  highlight,
  after,
  tone = "light",
  as: Tag = "h2",
  className = ""
}: SectionTitleProps) {
  const size = Tag === "h1" ? "text-[26px] leading-[1.1] sm:text-[2.6rem] sm:leading-[1.08]" : "text-[1.65rem] leading-[1.15] sm:text-[2.1rem]";
  return <Tag id={id} className={`text-balance font-display font-extrabold uppercase ${size} ${tone === "light" ? "text-navy" : "text-white"} ${className}`} data-id="element-196" data-mp="3m5e1qndjsdhl">
      {title}
      {highlight && <span className={tone === "light" ? "text-gold-gradient-deep" : "text-gold-gradient"} data-id="element-197" data-mp="3d8dfama1gpgs">
          {highlight}
        </span>}
      {after}
    </Tag>;
}